<template>
  <div class="the-navbar__user-meta flex items-center">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ nameOfUser }}</p>
      <!--<small>Available</small>-->
    </div>
    <div class="con-img ml-3" >
      <img key="onlineImg" src="https://api-flohmarktkoenig.sonono.ch/storage/app/images/users/placeholder.png" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
    </div>
    <div
      class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
      @click="logout">
      <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
      <span class="ml-2">Logout</span>
    </div>
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      nameOfUser: JSON.parse(localStorage.getItem('user')).firstname,
      isOpenDropDownMenu: false 
    }
  },
  mounted() {
   // setTimeout(() => { this.isOpenDropDownMenu = true }, 300)
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    logout() {
        this.$router.push('/pages/login').then(() => {
          localStorage.clear();
        }).catch(() => {})
    },
    goToProfilePage() {
      window.location.href = '/profile'
    }
  }
}
</script>
